<template>
  <transition name="slide">
    <div v-show="showError" class="error-message-wrapper">
      {{message}}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    message: {
      type: String,
    },
    showError: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less">
#fasttrack-crm {
  .error-message-wrapper {
    background-color: #b92a2a;
    color: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 10px;
    transition: all 0.5s ease-in-out;
    font-size: 12px;
  }

  .slide-enter-to,
  .slide-leave {
    margin-top: 0px;
  }

  .slide-enter,
  .slide-leave-to {
    margin-top: -100px;
  }
}
</style>
